<mat-toolbar *ngIf="!isHidden" color="primary" class="sticky">
  <mat-toolbar-row *ngIf="isLogged">
    <ng-container *appShellNoRender>
      <div *ngIf="isLogged && unreadMessages > 0; else profileButton" class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="['/'+inboxUrl]">
        <div class="thumbnail">
          <img class="inbox" src="{{licenceService.getKey('inbox-icon')}}" alt="inbox" />
          <!-- <div class="inbox-pulse"></div> -->
          <div *ngIf="unreadMessages > 0" class="notification-circle" fxLayout="row" fxLayoutAlign="center center">
            <span class="notification-number">{{unreadMessages}}</span>
          </div>  
        </div>
        <div class="name" i18n>inbox</div>
      </div>
    </ng-container>

    <div *ngIf="!isLogged" class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="['/'+singnUrl]">
      <div class="thumbnail">
        <img src="{{licenceService.getKey('signup-icon')}}"/>
        <div class="signup-pulse"></div>
      </div>
      <div class="name" i18n>sign up</div>
    </div>
    <span fxFlex></span>
    <div class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="mostPlayedUrl">
      <div class="thumbnail">
        <img src="{{licenceService.getKey('icon-hot-20')}}" alt="slots" />
      </div>
      <div class="name" i18n>Hot 20</div>
    </div>
    <span fxFlex></span>
    <div class="item deposit-btn" fxLayout="column" fxLayoutAlign="center center" [routerLink]="['/'+paymentUrl]">
      <img src="{{licenceService.getKey('icon-wallet-symbol-mob')}}" alt="wallet-symbol" class="middle" />
    </div>
    <span fxFlex></span>
    <div class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="plinkoUrl">
      <div class="thumbnail">
        <img src="{{licenceService.getKey('icon-easy-win-light-luckera')}}" alt="live-casino" />
        <!-- <mat-icon>money</mat-icon> -->
      </div>
      <div class="name">Easy Win</div>
    </div>
    <span fxFlex></span>
    <div class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="['/'+searchUrl]">
      <div class="thumbnail">
        <img src="{{licenceService.getKey('search-icon')}}" alt="search" />
      </div>
      <div class="name" i18n>search</div>
    </div>
  </mat-toolbar-row>
  <div *ngIf="!isLogged" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="login-signup-buttons" style="height: 100%;">
    <button class="btn-secondary" i18n style="width: 50%;" (click)="login()">Log in</button>
    <button class="btn-primary" i18n style="width: 50%;" (click)="signup()">Sign up</button>
  </div>
</mat-toolbar>

<ng-template #profileButton>
  <div *ngIf="isLogged" class="item" fxLayout="column" fxLayoutAlign="start center" [routerLink]="['/client-area/main']">
    <div class="profile-thumbnail">
      <app-profile-button></app-profile-button>
    </div>
  </div>
</ng-template>
